import { compose } from 'recompose';

import Project from './project';

const enhance = compose();
export default enhance(Project);
